module.exports = __webpack_public_path__ + "img/doc.f24e8433.png";